import { Navigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../store/auth.store";

function safeReturnTo(input: string | null): string {
  if (!input) return "/";
  if (input.startsWith("/") && !input.startsWith("//")) return input;
  return "/";
}

export function Login() {
  const [params] = useSearchParams();
  const returnTo = safeReturnTo(params.get("returnTo"));
  const errorMessage = params.get("error");
  const accessToken = useAuthStore((s) => s.accessToken);

  if (accessToken) {
    return <Navigate to={returnTo} replace />;
  }

  function entraHref(): string {
    const url = new URL("/api/v1/auth/entra/login", window.location.origin);
    url.searchParams.set("returnTo", returnTo);
    return url.toString();
  }

  return (
    <div className="login-page">
      <div className="card login-card">
        <h1>SWFIC Dashboard</h1>
        <p className="muted">
          Sign in with your SW Funk Industrial Microsoft account to access your apps.
        </p>
        {errorMessage && (
          <p
            style={{
              margin: "12px 0 0",
              padding: "10px 14px",
              borderRadius: 6,
              background: "rgba(239,68,68,0.12)",
              color: "#ef4444",
              fontSize: 14,
              lineHeight: 1.5,
            }}
          >
            {errorMessage}
          </p>
        )}
        <a
          href={entraHref()}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            padding: "10px 14px",
            borderRadius: 6,
            background: "#2563eb",
            color: "#fff",
            textDecoration: "none",
            fontWeight: 500,
            marginTop: 16,
          }}
        >
          <span aria-hidden="true" style={{ marginRight: 8 }}>⊞</span>
          Sign in with Microsoft
        </a>
      </div>
    </div>
  );
}
